// Keep each submission separately so an acknowledgement in another tab cannot
// erase an unconfirmed send. The index also reads older single-record drafts.
const indexKey=(owner,channel)=>`cad-chat-pending:${owner}:${channel}`;
const prefix=(owner,channel)=>`cad-chat-outbox:${owner}:${channel}:`;
const parse=value=>{try{return JSON.parse(value||'null');}catch{return null;}};
export function readChatPending(owner,channel) {
  const indexed=parse(localStorage.getItem(indexKey(owner,channel)));
  if(indexed?.channelId===channel&&indexed.clientMessageId)return indexed;
  const start=prefix(owner,channel);
  for(let i=0;i<localStorage.length;i++){
    const key=localStorage.key(i);
    if(key?.startsWith(start)){
      const pending=parse(localStorage.getItem(key));
      if(pending?.channelId===channel&&pending.clientMessageId)return pending;
    }
  }
  return null;
}
export function retainChatPending(owner,pending) {
  localStorage.setItem(prefix(owner,pending.channelId)+pending.clientMessageId,JSON.stringify(pending));
  localStorage.setItem(indexKey(owner,pending.channelId),JSON.stringify(pending));
}
export function acceptChatPending(owner,pending) {
  localStorage.removeItem(prefix(owner,pending.channelId)+pending.clientMessageId);
  const key=indexKey(owner,pending.channelId),indexed=parse(localStorage.getItem(key));
  if(indexed?.clientMessageId===pending.clientMessageId)localStorage.removeItem(key);
  const next=readChatPending(owner,pending.channelId);
  if(next)localStorage.setItem(key,JSON.stringify(next));
}
